/**
 * Box variable : une image ou un tableau que le formulaire liste pour être
 * rempli (`img_variable` / `table_variable` du classique).
 *
 * Sur le site, une box liée au CRM (Smart4) l'est par défaut : `showInForm`
 * reste `undefined` tant que l'admin n'a pas tranché, et son choix l'emporte.
 */

export const isVariableBox = ({ showInForm, boundToCrm }) => (
  typeof showInForm === 'boolean' ? showInForm : !!boundToCrm
);

/**
 * Box que le créateur de formulaire d'un modèle liste : toute box variable,
 * même retirée du formulaire. Le classique ne filtre pas `hideInForm` en
 * template (`FormItemsArray`) : décocher la garde dans la liste, switch
 * éteint, avec ses réglages. Une box qu'on a cochée puis décochée l'a été.
 */
export const isListedInTemplateForm = ({ showInForm, boundToCrm }) => (
  typeof showInForm === 'boolean' || !!boundToCrm
);

// Une box masquée dans le document (`hideField` du classique) quitte aussi le
// formulaire.
export const isListedInForm = ({ showInForm, boundToCrm, isVisible }) => (
  isVariableBox({ showInForm, boundToCrm }) && isVisible !== false
);

/**
 * Ce qu'une saisie du formulaire fige sur la box, pour qu'elle ne bouge plus
 * quand on change sa source :
 * - son affichage au formulaire : remplacer une image Smart4 la détache du
 *   CRM, elle en sortirait au moment même où on la remplit ;
 * - son nom, que le classique enregistre une fois pour toutes
 *   (`mutateVariablesBoxes`) : changer de variable ne la renomme pas.
 */
export const frozenFormProps = ({ showInForm, boundToCrm, name: currentName }, name) => ({
  ...(typeof showInForm === 'boolean' ? {} : { showInForm: isVariableBox({ showInForm, boundToCrm }) }),
  ...(currentName ? {} : { name }),
});
